exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-wrapper[data-v-69aace18]{margin-right:auto;display:flex;flex-direction:row;gap:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-69aace18&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/MessageManage/SMSTask/SMSTaskDetail.vue
// module id = 565
// module chunks = 0